export class Reward {
    text: string

    constructor(
        text: string
    ) {
        this.text = text
    }
}